import React from 'react';
import { Box, Typography, Card, CardContent, Stack, Button, Divider } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const memberships = [
    {
      title: "GOLD",
      includedFeatures: [
        "platform",
        "workshops",
        "mastermind",
        "events",
        "goalSession",
        "support",
        "exclusive",
        "personalPlan",
        "coaching",
      ],
      color: "#20defa",
      backgroundColor: "#20defa",
      recommended: true,
    },
];

const allMembershipFeatures = [
    {
      id: "platform",
      text: "<strong>Acces la platforma Academillion</strong> peste 21 de ore de cursuri și materiale din categoriile Money și Investments, ca să înveți în ritmul tău.",
    },
    {
      id: "workshops",
      text: "<strong>2 Workshopuri live lunare cu experți</strong> prin care înveți direct cum să investești inteligent.",
    },
    {
      id: "mastermind",
      text: "<strong>2 Sesiuni Online de Mastermind comunitar lunare</strong>  cu membri și investitori activi, în care lucrezi pe teme financiare concrete și primești feedback direct pentru provocările tale.",
    },
    {
      id: "events",
      text: "<strong>Evenimente de networking & experiențe</strong> educative, recreative si distractive împreună cu comunitatea, în funcție de interesele tale.",
    },
    {
      id: "goalSession",
      text: "<strong>Sesiune privată 1 la 1 de obiective</strong> cu un Community Leader care te ajută să-ți setezi obiectivele financiare. ",
    },
    {
      id: "support",
      text: "<strong>Sprijin personal constant</strong> de la un Community Leader ori de câte ori ai nevoie.",
    },
    {
      id: "exclusive",
      text: "<strong>Acces la produse investiționale negociate special pentru comunitatea noastră</strong>, însoțite de explicații și due diligence – tu iei decizia, dar știi exact <i>ce, cum și de ce.</i>",
    },
    {
      id: "coaching",
      text: "<strong>5 Sesiuni 1 la 1 de Coaching personalizat</strong> care te ajută să creezi și să monitorizezi un plan financiar adaptat ție si portofoliului tău.",
    },
];

const ProductSection = () => {
  return (
    <Box sx={{ py: { xs: 2, xxl: 6 }, backgroundColor: "#F4F4F4", textAlign: "center" }}>
        <Box
            sx={{
                width: { xs: "100%", xxl: "70%" },
                margin: "0 auto"
            }}
        >
            <Typography variant="h4"
                sx={{
                    mb: { xs: 2, xxl: 3 },
                    fontWeight: "bold", 
                    fontSize: { xs: "20px", xxl: "36px" },
                    color: '#002077',
                    px: 2
                }}
            >
                La ce să te aștepți, concret:
            </Typography>
            <Typography variant="body1" 
                sx={{
                px: 2, 
                mb: { xs: 2, xxl: 3 },
                color: "#000",
                fontSize: { xs: "14px", xxl: "21px" }, 
                textTransform: "none",
                fontWeight: "300", 
                }}
            >
                
            </Typography>

            {/* Membership Plans */}
            <Box 
                sx={{ 
                width: "100%",  
                overflowX: "auto", 
                display: "flex", 
                justifyContent: { xs: "flex-start", xxl: "center" }, 
                alignItems: "center",
                padding: "0 16px", 
                }}
            >
                <Stack
                direction="row"
                justifyContent="center"
                spacing={{ xs: 1, xxl: 3 }}
                sx={{
                    display: "inline-flex",
                    flexWrap: "nowrap",
                    minWidth: "max-content", 
                    margin: "0 auto", 
                    paddingLeft: { xs: "calc(30vw - 150px)", xxl: "0px" }, 
                }}
                >
                {memberships.map((membership, index) => (
                    <Box
                    key={index}
                    >
                    <Card
                        key={`${membership.id}-${index}`}
                        sx={{
                        backgroundColor: "#FFFFFF",
                        borderRadius: "16px",
                        width: { xs: "100%", xxl: "800px" },
                        border: '3px solid',
                        borderColor: "#002077",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        overflow: "hidden",
                        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <Box
                        sx={{
                            backgroundColor: membership.backgroundColor,
                            color: membership.color,
                            padding: "24px 16px",
                            textAlign: "center",
                        }}
                        >
                        <Typography
                            variant="h4"
                            sx={{
                            border: "0px",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            color: "#fff",
                            }}
                        >
                            {membership.title}
                        </Typography>
                        </Box>
                        <CardContent>
                        <Stack spacing={2} sx={{ mt: 2}}>
                            {allMembershipFeatures.map((feature, idx) => {
                            const included = membership.includedFeatures.includes(feature.id);
                            return (
                                <React.Fragment key={feature.id}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                                    {included ? (
                                    <CheckCircleOutlineIcon
                                        sx={{ color: membership.backgroundColor, fontSize: "18px" }}
                                    />
                                    ) : (
                                    <Box sx={{ width: "18px" }} /> // placeholder for alignment
                                    )}
                                    <Typography
                                    variant="body2"
                                    sx={{
                                        color: included ? "#5A5A5A" : "#B0B0B0",
                                        textAlign: "center",
                                        fontSize: { xs: "12px", xxl: "16px" },
                                        lineHeight: "1.5",
                                    }}
                                    dangerouslySetInnerHTML={{ __html: feature.text }}
                                    />
                                </Box>
                                {idx < allMembershipFeatures.length - 1 && (
                                    <Divider sx={{ my: 1, borderColor: "#E0E0E0" }} />
                                )}
                                </React.Fragment>
                            );
                            })}
                        </Stack>
                        </CardContent>
                    </Card>
                    </Box>
                ))}
                </Stack>
            </Box>

            <Button
                variant="contained"
                fullWidth={false}
                href="/contact"
                sx={{
                mt: { xs: 2, xxl: 4 },
                px: { xs: 2, sm: 4 },
                py: { xs: 0, sm: 2 },
                backgroundColor: "#002077",
                color: "#20defa",
                borderRadius: "16px",
                textTransform: "none",
                fontWeight: "700", 
                fontSize: { xs: "16px", sm: "18px", md: "20px" }, 
                lineHeight: "14px",
                letterSpacing: "normal",
                "&:hover": {
                    backgroundColor: "#20defa",
                    color: "#fff",
                },
                }}
            >
                Vreau în academillion
            </Button>
        </Box>
    </Box>
  );
};

export default ProductSection;